// import React, { useRef, useEffect, useState } from "react";

// /* ─── SVG Text Logos ─── */

// const DalmiaLogo = () => (
//   <svg viewBox="0 0 220 72" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-full">
//     <text x="110" y="34" fontFamily="Georgia,serif" fontSize="26" fontWeight="700" fill="#111" textAnchor="middle" letterSpacing="3">DALMIA</text>
//     <line x1="30" y1="40" x2="190" y2="40" stroke="#ccc" strokeWidth="0.8" />
//     <text x="110" y="58" fontFamily="Arial,sans-serif" fontSize="15" fill="#555" textAnchor="middle" letterSpacing="4">STAINLESS STEEL</text>
//   </svg>
// );

// const SiyaramLogo = () => (
//   <svg viewBox="0 0 220 72" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-full">
//     <text x="110" y="30" fontFamily="Georgia,serif" fontSize="27" fontWeight="700" fill="#111" textAnchor="middle" letterSpacing="2">SIYARAM</text>
//     <text x="110" y="54" fontFamily="Arial,sans-serif" fontSize="13" fill="#777" textAnchor="middle" letterSpacing="3">IRRIGATION PVT LTD</text>
//     <rect x="80" y="59" width="60" height="1" fill="#bbb" />
//   </svg>
// );

// const LoveCraftLogo = () => (
//   <svg viewBox="0 0 220 72" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-full">
//     <text x="110" y="28" fontFamily="Georgia,serif" fontSize="22" fontStyle="italic" fill="#111" textAnchor="middle" letterSpacing="3">Love Craft</text>
//     <text x="110" y="54" fontFamily="Arial,sans-serif" fontSize="14" fill="#888" textAnchor="middle" letterSpacing="5">GIFT</text>
//     <circle cx="110" cy="62" r="2" fill="#bbb" />
//   </svg>
// );

// const TirupatiLogo = () => (
//   <svg viewBox="0 0 220 80" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-full">
//     <polyline points="90,22 110,6 130,22" fill="none" stroke="#111" strokeWidth="1.5" strokeLinejoin="round" />
//     <rect x="97" y="22" width="12" height="14" fill="none" stroke="#111" strokeWidth="1.5" />
//     <text x="110" y="56" fontFamily="Georgia,serif" fontSize="22" fontWeight="700" fill="#111" textAnchor="middle" letterSpacing="2">TIRUPATI</text>
//     <text x="110" y="72" fontFamily="Arial,sans-serif" fontSize="12" fill="#777" textAnchor="middle" letterSpacing="3.5">PROPERTY</text>
//   </svg>
// );

// const StJohnLogo = () => (
//   <svg viewBox="0 0 220 80" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-full">
//     <rect x="107" y="4" width="6" height="22" rx="1" fill="#cc0000" />
//     <rect x="100" y="11" width="20" height="6" rx="1" fill="#cc0000" />
//     <text x="110" y="48" fontFamily="Arial,sans-serif" fontSize="20" fontWeight="700" fill="#111" textAnchor="middle" letterSpacing="1">ST. JOHN</text>
//     <text x="110" y="66" fontFamily="Arial,sans-serif" fontSize="13" fill="#666" textAnchor="middle" letterSpacing="2.5">AMBULANCE</text>
//   </svg>
// );

// const BRInsuranceLogo = () => (
//   <svg viewBox="0 0 220 82" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-full">
//     <rect x="91" y="4" width="38" height="30" rx="4" fill="none" stroke="#111" strokeWidth="1.5" />
//     <text x="110" y="27" fontFamily="Georgia,serif" fontSize="20" fontWeight="700" fill="#111" textAnchor="middle">BR</text>
//     <text x="110" y="54" fontFamily="Arial,sans-serif" fontSize="19" fontWeight="700" fill="#111" textAnchor="middle" letterSpacing="1">INSURANCE</text>
//     <text x="110" y="70" fontFamily="Arial,sans-serif" fontSize="12" fill="#888" textAnchor="middle" letterSpacing="3">SERVICES</text>
//   </svg>
// );

// const CloseFriendsLogo = () => (
//   <svg viewBox="0 0 220 72" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-full">
//     <text x="110" y="28" fontFamily="Georgia,serif" fontSize="20" fontStyle="italic" fill="#111" textAnchor="middle" letterSpacing="2">Close Friends</text>
//     <line x1="40" y1="36" x2="180" y2="36" stroke="#ddd" strokeWidth="0.8" />
//     <text x="110" y="55" fontFamily="Arial,sans-serif" fontSize="14" fill="#777" textAnchor="middle" letterSpacing="4">TRADERS</text>
//   </svg>
// );

// const MaharLogo = () => (
//   <svg viewBox="0 0 220 72" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-full">
//     <text x="110" y="46" fontFamily="Georgia,serif" fontSize="40" fontWeight="300" fill="#111" textAnchor="middle" letterSpacing="8">MAHAR</text>
//     <line x1="40" y1="54" x2="180" y2="54" stroke="#bbb" strokeWidth="0.8" />
//   </svg>
// );

// const VontasLogo = () => (
//   <svg viewBox="0 0 220 72" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-full">
//     <text x="110" y="28" fontFamily="Arial,sans-serif" fontSize="26" fontWeight="800" fill="#111" textAnchor="middle" letterSpacing="3">VONTAS</text>
//     <text x="110" y="50" fontFamily="Arial,sans-serif" fontSize="13" fill="#888" textAnchor="middle" letterSpacing="3">SS DOOR INDUSTRIES</text>
//     <rect x="40" y="55" width="140" height="1.2" fill="#111" />
//   </svg>
// );

// const MayaTravelsLogo = () => (
//   <svg viewBox="0 0 220 80" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-full">
//     <path d="M90 18 Q96 6 102 18 Q108 6 114 18 Q120 6 126 18" fill="none" stroke="#111" strokeWidth="1.5" strokeLinecap="round" />
//     <text x="110" y="50" fontFamily="Georgia,serif" fontSize="24" fontStyle="italic" fontWeight="600" fill="#111" textAnchor="middle" letterSpacing="1">Maya</text>
//     <text x="110" y="68" fontFamily="Arial,sans-serif" fontSize="13" fill="#777" textAnchor="middle" letterSpacing="4">TRAVELS</text>
//   </svg>
// );

// const GermanMantraLogo = () => (
//   <svg viewBox="0 0 220 82" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-full">
//     <rect x="91" y="4" width="38" height="30" rx="4" fill="#111" />
//     <text x="110" y="27" fontFamily="Georgia,serif" fontSize="22" fontWeight="700" fill="#fff" textAnchor="middle">G</text>
//     <text x="110" y="56" fontFamily="Arial,sans-serif" fontSize="21" fontWeight="800" fill="#111" textAnchor="middle" letterSpacing="2">GERMAN</text>
//     <text x="110" y="72" fontFamily="Arial,sans-serif" fontSize="14" fill="#777" textAnchor="middle" letterSpacing="3.5">MANTRA</text>
//   </svg>
// );

// const UrbanicLogo = () => (
//   <svg viewBox="0 0 220 72" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-full">
//     <text x="110" y="36" fontFamily="Georgia,serif" fontSize="28" fontWeight="300" fill="#111" textAnchor="middle" letterSpacing="6">URBANIC</text>
//     <text x="110" y="56" fontFamily="Arial,sans-serif" fontSize="14" fill="#999" textAnchor="middle" letterSpacing="5">INDIA</text>
//   </svg>
// );

// const GTRealityLogo = () => (
//   <svg viewBox="0 0 220 82" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-full">
//     <rect x="91" y="4" width="38" height="30" rx="2" fill="none" stroke="#111" strokeWidth="1.5" />
//     <text x="110" y="26" fontFamily="Arial,sans-serif" fontSize="17" fontWeight="800" fill="#111" textAnchor="middle">GT</text>
//     <text x="110" y="54" fontFamily="Arial,sans-serif" fontSize="17" fontWeight="700" fill="#111" textAnchor="middle" letterSpacing="1">THE GT</text>
//     <text x="110" y="70" fontFamily="Arial,sans-serif" fontSize="13" fill="#777" textAnchor="middle" letterSpacing="3">REALITY</text>
//   </svg>
// );

// const MifcoLogo = () => (
//   <svg viewBox="0 0 220 72" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-full">
//     <text x="110" y="46" fontFamily="Arial,sans-serif" fontSize="42" fontWeight="800" fill="#111" textAnchor="middle" letterSpacing="4">MIFCO</text>
//     <line x1="20" y1="54" x2="200" y2="54" stroke="#ddd" strokeWidth="1" />
//   </svg>
// );

// const WelcomeFincorpLogo = () => (
//   <svg viewBox="0 0 220 72" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-full">
//     <text x="110" y="22" fontFamily="Arial,sans-serif" fontSize="14" fill="#888" textAnchor="middle" letterSpacing="3">WELCOME</text>
//     <text x="110" y="46" fontFamily="Georgia,serif" fontSize="24" fontWeight="700" fill="#111" textAnchor="middle" letterSpacing="2">FINCORP</text>
//     <text x="110" y="63" fontFamily="Arial,sans-serif" fontSize="13" fill="#aaa" textAnchor="middle" letterSpacing="4">CAPITAL</text>
//   </svg>
// );

// /* ─── Client data ─── */
// const CLIENTS = [
//   { id: 1,  name: "Dalmia Stainless Steel",    Logo: DalmiaLogo },
//   { id: 2,  name: "Siyaram Irrigation Pvt Ltd", Logo: SiyaramLogo },
//   { id: 3,  name: "Love Craft Gift",             Logo: LoveCraftLogo },
//   { id: 4,  name: "Tirupati Property",           Logo: TirupatiLogo },
//   { id: 5,  name: "St. John Ambulance",          Logo: StJohnLogo },
//   { id: 6,  name: "BR Insurance",                Logo: BRInsuranceLogo },
//   { id: 7,  name: "Close Friends Traders",       Logo: CloseFriendsLogo },
//   { id: 8,  name: "Mahar",                       Logo: MaharLogo },
//   { id: 9,  name: "Vontas SS Door Industries",   Logo: VontasLogo },
//   { id: 10, name: "Maya Travels",                Logo: MayaTravelsLogo },
//   { id: 11, name: "German Mantra",               Logo: GermanMantraLogo },
//   { id: 12, name: "Urbanic India",               Logo: UrbanicLogo },
//   { id: 13, name: "The GT Reality",              Logo: GTRealityLogo },
//   { id: 14, name: "Mifco",                       Logo: MifcoLogo },
//   { id: 15, name: "Welcome Fincorp Capital",     Logo: WelcomeFincorpLogo },
// ];

// const COLS = 5;

// /* ─── useInView hook (replaces framer-motion's useInView) ─── */
// function useInView(ref, { once = true, margin = "0px" } = {}) {
//   const [inView, setInView] = useState(false);

//   useEffect(() => {
//     const el = ref.current;
//     if (!el) return;

//     const observer = new IntersectionObserver(
//       ([entry]) => {
//         if (entry.isIntersecting) {
//           setInView(true);
//           if (once) observer.disconnect();
//         } else if (!once) {
//           setInView(false);
//         }
//       },
//       { rootMargin: margin }
//     );

//     observer.observe(el);
//     return () => observer.disconnect();
//   }, [ref, once, margin]);

//   return inView;
// }

// /* ─── Single card ─── */
// const ClientCard = ({ client, index }) => (
//   <div
//     className="client-card relative flex items-center justify-center bg-white border border-gray-100 rounded-lg overflow-hidden cursor-pointer group transition-all duration-300 hover:border-gray-300 hover:shadow-md"
//     style={{
//       aspectRatio: "4/3",
//       opacity: 0,
//       animation: `fadeSlideUp 0.46s cubic-bezier(0.22,1,0.36,1) forwards`,
//       animationDelay: `${index * 0.05}s`,
//     }}
//   >
//     <div className="w-[85%] h-[75%] flex items-center justify-center transition-transform duration-300 group-hover:scale-105">
//       <client.Logo />
//     </div>
//   </div>
// );

// /* ─── Main component ─── */
// export default function OurClients() {
//   const gridRef = useRef(null);
//   const isInView = useInView(gridRef, { once: true, margin: "-80px" });

//   const rows = [];
//   for (let i = 0; i < CLIENTS.length; i += COLS) {
//     rows.push(CLIENTS.slice(i, i + COLS));
//   }

//   return (
//     <>
//       <style>{`
//         @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&family=Fraunces:wght@700;900&display=swap');

//         @keyframes fadeSlideUp {
//           from { opacity: 0; transform: translateY(16px); }
//           to   { opacity: 1; transform: translateY(0); }
//         }
//         @keyframes slideUp {
//           from { transform: translateY(110%); }
//           to   { transform: translateY(0); }
//         }
//         @keyframes scaleInX {
//           from { transform: scaleX(0); }
//           to   { transform: scaleX(1); }
//         }
//         @keyframes fadeIn {
//           from { opacity: 0; }
//           to   { opacity: 1; }
//         }

//         .clients-heading { font-family: 'Fraunces', serif; }
//         .clients-body    { font-family: 'Plus Jakarta Sans', sans-serif; }

//         .heading-word {
//           display: inline-block;
//           overflow: hidden;
//           line-height: 1;
//         }
//         .heading-word span {
//           display: block;
//           animation: slideUp 0.8s cubic-bezier(0.22,1,0.36,1) forwards;
//           opacity: 1;
//         }
//         .heading-word:nth-child(1) span { animation-delay: 0.2s; }
//         .heading-word:nth-child(2) span { animation-delay: 0.34s; }

//         .divider-line {
//           animation: scaleInX 1.1s cubic-bezier(0.22,1,0.36,1) 0.55s forwards;
//           transform: scaleX(0);
//           transform-origin: left;
//         }
//         .label-fade {
//           animation: fadeIn 0.55s ease 0.1s forwards;
//           opacity: 0;
//         }
//         .footer-fade {
//           animation: fadeIn 0.9s ease 1.2s forwards;
//           opacity: 0;
//         }
//       `}</style>

//       <section
//         id="clients"
//         className="clients-body py-16 relative bg-gradient-to-b from-white to-blue-50 overflow-hidden"
//       >
//         {/* Decorative blobs */}
//         <div className="absolute top-0 right-0 w-72 h-72 bg-blue-100/50 rounded-full blur-3xl pointer-events-none" />
//         <div className="absolute bottom-0 left-0 w-80 h-80 bg-sky-100/40 rounded-full blur-3xl pointer-events-none" />

//         <div className="max-w-7xl mx-auto px-5 md:px-10 relative">

//           {/* Header */}
//           <div className="mb-12">
// <p className="trust-body inline-block text-sm font-bold mb-4 text-blue-600 tracking-widest uppercase">
//                   -: Our Recently Done Client's :-
//             </p>
// <div className="flex flex-row gap-3 flex-wrap items-baseline mb-5">
//   {["OUR", "CLIENTS"].map((word, wi) => (
//     <div key={wi} className="heading-word">
//       <span
//         className="clients-heading font-black"
//         style={{
//           fontSize: "clamp(48px, 8vw, 96px)",
//           letterSpacing: "-0.02em",
//           animationDelay: `${0.2 + wi * 0.14}s`,
//           ...(word === "CLIENTS"
//             ? {
//                 background:
//                   "linear-gradient(135deg,#1d4ed8 0%,#0ea5e9 100%)",
//                 WebkitBackgroundClip: "text",
//                 WebkitTextFillColor: "transparent",
//                 backgroundClip: "text",
//               }
//             : {
//                 color: "#000",
//               }),
//         }}
//       >
//         {word}
//       </span>
//     </div>
//   ))}
// </div>

//             <div
//               className="divider-line h-px max-w-[220px]"
//               style={{
//                 background: "linear-gradient(90deg, #2563eb, #0ea5e9)",
//               }}
//             />
//           </div>

//           {/* Grid */}
//           <div ref={gridRef}>
//             {isInView &&
//               rows.map((row, ri) => {
//                 const isLastRow = ri === rows.length - 1;
//                 const padded = isLastRow
//                   ? [...row, ...Array(COLS - row.length).fill(null)]
//                   : row;

//                 return (
//                   <div
//                     key={ri}
//                     className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-5 gap-3 mb-3"
//                   >
//                     {padded.map((client, ci) =>
//                       client ? (
//                         <ClientCard
//                           key={client.id}
//                           client={client}
//                           index={ri * COLS + ci}
//                         />
//                       ) : (
//                         <div
//                           key={`filler-${ci}`}
//                           className="rounded-lg hidden lg:block"
//                           style={{ aspectRatio: "4/3" }}
//                         />
//                       )
//                     )}
//                   </div>
//                 );
//               })}
//           </div>

//           {/* Footer note */}
//           <p className="footer-fade clients-body text-center text-sm text-slate-400 font-medium mt-8 tracking-widest">
//             — 100+ TRUSTED PARTNERS ACROSS VARIOUS INDUSTRIES —
//           </p>
//         </div>
//       </section>
//     </>
//   );
// }






import React, { useRef, useEffect, useState } from "react";

const DalmiaLogo = () => (
  <svg viewBox="0 0 220 72" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-full">
    <text x="110" y="34" fontFamily="Georgia,serif" fontSize="26" fontWeight="700" fill="#111" textAnchor="middle" letterSpacing="3">DALMIA</text>
    <line x1="30" y1="40" x2="190" y2="40" stroke="#ccc" strokeWidth="0.8" />
    <text x="110" y="58" fontFamily="Arial,sans-serif" fontSize="15" fill="#555" textAnchor="middle" letterSpacing="4">STAINLESS STEEL</text>
  </svg>
);

const SiyaramLogo = () => (
  <svg viewBox="0 0 220 72" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-full">
    <text x="110" y="30" fontFamily="Georgia,serif" fontSize="27" fontWeight="700" fill="#111" textAnchor="middle" letterSpacing="2">SIYARAM</text>
    <text x="110" y="54" fontFamily="Arial,sans-serif" fontSize="13" fill="#777" textAnchor="middle" letterSpacing="3">IRRIGATION PVT LTD</text>
    <rect x="80" y="59" width="60" height="1" fill="#bbb" />
  </svg>
);

const LoveCraftLogo = () => (
  <svg viewBox="0 0 220 72" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-full">
    <text x="110" y="28" fontFamily="Georgia,serif" fontSize="22" fontStyle="italic" fill="#111" textAnchor="middle" letterSpacing="3">Love Craft</text>
    <text x="110" y="54" fontFamily="Arial,sans-serif" fontSize="14" fill="#888" textAnchor="middle" letterSpacing="5">GIFT</text>
    <circle cx="110" cy="62" r="2" fill="#bbb" />
  </svg>
);

const TirupatiLogo = () => (
  <svg viewBox="0 0 220 80" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-full">
    <polyline points="90,22 110,6 130,22" fill="none" stroke="#111" strokeWidth="1.5" strokeLinejoin="round" />
    <rect x="97" y="22" width="12" height="14" fill="none" stroke="#111" strokeWidth="1.5" />
    <text x="110" y="56" fontFamily="Georgia,serif" fontSize="22" fontWeight="700" fill="#111" textAnchor="middle" letterSpacing="2">TIRUPATI</text>
    <text x="110" y="72" fontFamily="Arial,sans-serif" fontSize="12" fill="#777" textAnchor="middle" letterSpacing="3.5">PROPERTY</text>
  </svg>
);

const StJohnLogo = () => (
  <svg viewBox="0 0 220 80" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-full">
    <rect x="107" y="4" width="6" height="22" rx="1" fill="#cc0000" />
    <rect x="100" y="11" width="20" height="6" rx="1" fill="#cc0000" />
    <text x="110" y="48" fontFamily="Arial,sans-serif" fontSize="20" fontWeight="700" fill="#111" textAnchor="middle" letterSpacing="1">ST. JOHN</text>
    <text x="110" y="66" fontFamily="Arial,sans-serif" fontSize="13" fill="#666" textAnchor="middle" letterSpacing="2.5">AMBULANCE</text>
  </svg>
);

const BRInsuranceLogo = () => (
  <svg viewBox="0 0 220 82" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-full">
    <rect x="91" y="4" width="38" height="30" rx="4" fill="none" stroke="#111" strokeWidth="1.5" />
    <text x="110" y="27" fontFamily="Georgia,serif" fontSize="20" fontWeight="700" fill="#111" textAnchor="middle">BR</text>
    <text x="110" y="54" fontFamily="Arial,sans-serif" fontSize="19" fontWeight="700" fill="#111" textAnchor="middle" letterSpacing="1">INSURANCE</text>
    <text x="110" y="70" fontFamily="Arial,sans-serif" fontSize="12" fill="#888" textAnchor="middle" letterSpacing="3">SERVICES</text>
  </svg>
);

const CloseFriendsLogo = () => (
  <svg viewBox="0 0 220 72" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-full">
    <text x="110" y="28" fontFamily="Georgia,serif" fontSize="20" fontStyle="italic" fill="#111" textAnchor="middle" letterSpacing="2">Close Friends</text>
    <line x1="40" y1="36" x2="180" y2="36" stroke="#ddd" strokeWidth="0.8" />
    <text x="110" y="55" fontFamily="Arial,sans-serif" fontSize="14" fill="#777" textAnchor="middle" letterSpacing="4">TRADERS</text>
  </svg>
);

const MaharLogo = () => (
  <svg viewBox="0 0 220 72" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-full">
    <text x="110" y="46" fontFamily="Georgia,serif" fontSize="40" fontWeight="300" fill="#111" textAnchor="middle" letterSpacing="8">MAHAR</text>
    <line x1="40" y1="54" x2="180" y2="54" stroke="#bbb" strokeWidth="0.8" />
  </svg>
);

const VontasLogo = () => (
  <svg viewBox="0 0 220 72" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-full">
    <text x="110" y="28" fontFamily="Arial,sans-serif" fontSize="26" fontWeight="800" fill="#111" textAnchor="middle" letterSpacing="3">VONTAS</text>
    <text x="110" y="50" fontFamily="Arial,sans-serif" fontSize="13" fill="#888" textAnchor="middle" letterSpacing="3">SS DOOR INDUSTRIES</text>
    <rect x="40" y="55" width="140" height="1.2" fill="#111" />
  </svg>
);

const MayaTravelsLogo = () => (
  <svg viewBox="0 0 220 80" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-full">
    <path d="M90 18 Q96 6 102 18 Q108 6 114 18 Q120 6 126 18" fill="none" stroke="#111" strokeWidth="1.5" strokeLinecap="round" />
    <text x="110" y="50" fontFamily="Georgia,serif" fontSize="24" fontStyle="italic" fontWeight="600" fill="#111" textAnchor="middle" letterSpacing="1">Maya</text>
    <text x="110" y="68" fontFamily="Arial,sans-serif" fontSize="13" fill="#777" textAnchor="middle" letterSpacing="4">TRAVELS</text>
  </svg>
);

const GermanMantraLogo = () => (
  <svg viewBox="0 0 220 82" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-full">
    <rect x="91" y="4" width="38" height="30" rx="4" fill="#111" />
    <text x="110" y="27" fontFamily="Georgia,serif" fontSize="22" fontWeight="700" fill="#fff" textAnchor="middle">G</text>
    <text x="110" y="56" fontFamily="Arial,sans-serif" fontSize="21" fontWeight="800" fill="#111" textAnchor="middle" letterSpacing="2">GERMAN</text>
    <text x="110" y="72" fontFamily="Arial,sans-serif" fontSize="14" fill="#777" textAnchor="middle" letterSpacing="3.5">MANTRA</text>
  </svg>
);

const UrbanicLogo = () => (
  <svg viewBox="0 0 220 72" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-full">
    <text x="110" y="36" fontFamily="Georgia,serif" fontSize="28" fontWeight="300" fill="#111" textAnchor="middle" letterSpacing="6">URBANIC</text>
    <text x="110" y="56" fontFamily="Arial,sans-serif" fontSize="14" fill="#999" textAnchor="middle" letterSpacing="5">INDIA</text>
  </svg>
);

const GTRealityLogo = () => (
  <svg viewBox="0 0 220 82" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-full">
    <rect x="91" y="4" width="38" height="30" rx="2" fill="none" stroke="#111" strokeWidth="1.5" />
    <text x="110" y="26" fontFamily="Arial,sans-serif" fontSize="17" fontWeight="800" fill="#111" textAnchor="middle">GT</text>
    <text x="110" y="54" fontFamily="Arial,sans-serif" fontSize="17" fontWeight="700" fill="#111" textAnchor="middle" letterSpacing="1">THE GT</text>
    <text x="110" y="70" fontFamily="Arial,sans-serif" fontSize="13" fill="#777" textAnchor="middle" letterSpacing="3">REALITY</text>
  </svg>
);

const MifcoLogo = () => (
  <svg viewBox="0 0 220 72" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-full">
    <text x="110" y="46" fontFamily="Arial,sans-serif" fontSize="42" fontWeight="800" fill="#111" textAnchor="middle" letterSpacing="4">MIFCO</text>
    <line x1="20" y1="54" x2="200" y2="54" stroke="#ddd" strokeWidth="1" />
  </svg>
);

const WelcomeFincorpLogo = () => (
  <svg viewBox="0 0 220 72" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-full">
    <text x="110" y="22" fontFamily="Arial,sans-serif" fontSize="14" fill="#888" textAnchor="middle" letterSpacing="3">WELCOME</text>
    <text x="110" y="46" fontFamily="Georgia,serif" fontSize="24" fontWeight="700" fill="#111" textAnchor="middle" letterSpacing="2">FINCORP</text>
    <text x="110" y="63" fontFamily="Arial,sans-serif" fontSize="13" fill="#aaa" textAnchor="middle" letterSpacing="4">CAPITAL</text>
  </svg>
);

/* ─── Client data ─── */
const CLIENTS = [
  { id: 1,  name: "Dalmia Stainless Steel",    Logo: DalmiaLogo },
  { id: 2,  name: "Siyaram Irrigation Pvt Ltd", Logo: SiyaramLogo },
  { id: 3,  name: "Love Craft Gift",             Logo: LoveCraftLogo },
  { id: 4,  name: "Tirupati Property",           Logo: TirupatiLogo },
  { id: 5,  name: "St. John Ambulance",          Logo: StJohnLogo },
  { id: 6,  name: "BR Insurance",                Logo: BRInsuranceLogo },
  { id: 7,  name: "Close Friends Traders",       Logo: CloseFriendsLogo },
  { id: 8,  name: "Mahar",                       Logo: MaharLogo },
  { id: 9,  name: "Vontas SS Door Industries",   Logo: VontasLogo },
  { id: 10, name: "Maya Travels",                Logo: MayaTravelsLogo },
  { id: 11, name: "German Mantra",               Logo: GermanMantraLogo },
  { id: 12, name: "Urbanic India",               Logo: UrbanicLogo },
  { id: 13, name: "The GT Reality",              Logo: GTRealityLogo },
  { id: 14, name: "Mifco",                       Logo: MifcoLogo },
  { id: 15, name: "Welcome Fincorp Capital",     Logo: WelcomeFincorpLogo },
];

const COLS = 5;

/* ─── useInView hook ─── */
function useInView(ref, { once = true, margin = "0px" } = {}) {
  const [inView, setInView] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setInView(true);
          if (once) observer.disconnect();
        } else if (!once) {
          setInView(false);
        }
      },
      { rootMargin: margin }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, [ref, once, margin]);

  return inView;
}

/* ─── Single card ─── */
const ClientCard = ({ client, index }) => (
  <div
    className="client-card relative flex items-center justify-center bg-white border border-gray-100 rounded-lg overflow-hidden cursor-pointer group transition-all duration-300 hover:border-gray-300 hover:shadow-md"
    style={{
      aspectRatio: "4/3",
      opacity: 0,
      animation: `fadeSlideUp 0.46s cubic-bezier(0.22,1,0.36,1) forwards`,
      animationDelay: `${index * 0.05}s`,
    }}
  >
    <div className="w-[85%] h-[75%] flex items-center justify-center transition-transform duration-300 group-hover:scale-105">
      <client.Logo />
    </div>
  </div>
);

/* ─── Main component ─── */
export default function OurClients() {
  const gridRef = useRef(null);
  const isInView = useInView(gridRef, { once: true, margin: "-80px" });

  // Desktop rows: groups of 5
  const desktopRows = [];
  for (let i = 0; i < CLIENTS.length; i += COLS) {
    desktopRows.push(CLIENTS.slice(i, i + COLS));
  }

  // Mobile rows: groups of 2
  const mobileRows = [];
  for (let i = 0; i < CLIENTS.length; i += 2) {
    mobileRows.push(CLIENTS.slice(i, i + 2));
  }

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&family=Fraunces:wght@700;900&display=swap');

        @keyframes fadeSlideUp {
          from { opacity: 0; transform: translateY(16px); }
          to   { opacity: 1; transform: translateY(0); }
        }
        @keyframes slideUp {
          from { transform: translateY(110%); }
          to   { transform: translateY(0); }
        }
        @keyframes scaleInX {
          from { transform: scaleX(0); }
          to   { transform: scaleX(1); }
        }
        @keyframes fadeIn {
          from { opacity: 0; }
          to   { opacity: 1; }
        }

        .clients-heading { font-family: 'Fraunces', serif; }
        .clients-body    { font-family: 'Plus Jakarta Sans', sans-serif; }

        .heading-word {
          display: inline-block;
          overflow: hidden;
          line-height: 1;
        }
        .heading-word span {
          display: block;
          animation: slideUp 0.8s cubic-bezier(0.22,1,0.36,1) forwards;
          opacity: 1;
        }
        .heading-word:nth-child(1) span { animation-delay: 0.2s; }
        .heading-word:nth-child(2) span { animation-delay: 0.34s; }

        .divider-line {
          animation: scaleInX 1.1s cubic-bezier(0.22,1,0.36,1) 0.55s forwards;
          transform: scaleX(0);
          transform-origin: left;
        }
        .footer-fade {
          animation: fadeIn 0.9s ease 1.2s forwards;
          opacity: 0;
        }

        /* Mobile grid: 2 columns, last odd card centered */
        .mobile-grid {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 12px;
          margin-bottom: 12px;
        }
        .mobile-grid.single-card {
          grid-template-columns: 1fr;
          max-width: 50%;
          margin-left: auto;
          margin-right: auto;
        }

        /* Desktop grid: always 5 columns */
        @media (min-width: 1024px) {
          .mobile-grid,
          .mobile-grid.single-card {
            display: none !important;
          }
          .desktop-grid-row {
            display: grid !important;
          }
        }

        /* Hide desktop rows on mobile/tablet */
        .desktop-grid-row {
          display: none;
          grid-template-columns: repeat(5, 1fr);
          gap: 12px;
          margin-bottom: 12px;
        }

        @media (min-width: 640px) and (max-width: 1023px) {
          .mobile-grid {
            display: grid;
          }
          .desktop-grid-row {
            display: none !important;
          }
        }
      `}</style>

      <section
        id="clients"
        className="clients-body py-16 relative bg-gradient-to-b from-white to-blue-50 overflow-hidden"
      >
        {/* Decorative blobs */}
        <div className="absolute top-0 right-0 w-72 h-72 bg-blue-100/50 rounded-full blur-3xl pointer-events-none" />
        <div className="absolute bottom-0 left-0 w-80 h-80 bg-sky-100/40 rounded-full blur-3xl pointer-events-none" />

        <div className="max-w-7xl mx-auto px-5 md:px-10 relative">

          {/* Header */}
          <div className="mb-12">
            <p className="inline-block text-sm font-bold mb-4 text-blue-600 tracking-widest uppercase">
              -: Our Recently Done Client's :-
            </p>
            <div className="flex flex-row gap-3 flex-wrap items-baseline mb-5">
              {["OUR", "CLIENTS"].map((word, wi) => (
                <div key={wi} className="heading-word">
                  <span
                    className="clients-heading font-black"
                    style={{
                      fontSize: "clamp(48px, 8vw, 96px)",
                      letterSpacing: "-0.02em",
                      animationDelay: `${0.2 + wi * 0.14}s`,
                      ...(word === "CLIENTS"
                        ? {
                            background: "linear-gradient(135deg,#1d4ed8 0%,#0ea5e9 100%)",
                            WebkitBackgroundClip: "text",
                            WebkitTextFillColor: "transparent",
                            backgroundClip: "text",
                          }
                        : { color: "#000" }),
                    }}
                  >
                    {word}
                  </span>
                </div>
              ))}
            </div>
            <div
              className="divider-line h-px max-w-[220px]"
              style={{ background: "linear-gradient(90deg, #2563eb, #0ea5e9)" }}
            />
          </div>

          {/* Grid */}
          <div ref={gridRef}>
            {isInView && (
              <>
                {/* ── MOBILE & TABLET: rows of 2 ── */}
                {mobileRows.map((row, ri) => {
                  const isSingle = row.length === 1;
                  return (
                    <div
                      key={`m-${ri}`}
                      className={`mobile-grid${isSingle ? " single-card" : ""}`}
                    >
                      {row.map((client, ci) => (
                        <ClientCard
                          key={client.id}
                          client={client}
                          index={ri * 2 + ci}
                        />
                      ))}
                    </div>
                  );
                })}

                {/* ── DESKTOP: rows of 5 ── */}
                {desktopRows.map((row, ri) => {
                  const padded = [...row, ...Array(COLS - row.length).fill(null)];
                  return (
                    <div key={`d-${ri}`} className="desktop-grid-row">
                      {padded.map((client, ci) =>
                        client ? (
                          <ClientCard
                            key={client.id}
                            client={client}
                            index={ri * COLS + ci}
                          />
                        ) : (
                          <div
                            key={`filler-${ci}`}
                            className="rounded-lg"
                            style={{ aspectRatio: "4/3" }}
                          />
                        )
                      )}
                    </div>
                  );
                })}
              </>
            )}
          </div>

          {/* Footer note */}
          <p className="footer-fade clients-body text-center text-sm text-slate-400 font-medium mt-8 tracking-widest">
            — 100+ TRUSTED PARTNERS ACROSS VARIOUS INDUSTRIES —
          </p>
        </div>
      </section>
    </>
  );
}